import styled from 'styled-components'
import { Modal } from 'react-bootstrap'
import {
  createMeetingRoomModalDialogStyles,
  meetingRoomModalHeaderStyles,
  MEETING_ROOM_MODAL_WIDTH,
} from 'domain/feature/hub/company/meeting-room/shared/meetingRoomModalStyles'

export const StyledModal = styled(Modal)`
  ${createMeetingRoomModalDialogStyles(MEETING_ROOM_MODAL_WIDTH)}
  ${meetingRoomModalHeaderStyles}

  &.modal {
    display: flex !important;
    align-items: center;
    justify-content: center;
  }

  .modal-dialog {
    margin: auto;
  }

  .modal-body {
    padding: 24px;
    flex: 1;
  }

  .modal-footer {
    border-top: none;
    padding: 8px 24px 24px;
    justify-content: flex-end;
    gap: 8px;
    flex-shrink: 0;

    @media screen and (max-width: 768px) {
      padding: 8px 16px 16px;
    }
  }

  @media screen and (max-width: 768px) {
    .modal-body {
      padding: 16px;
    }
  }
`

export const FormFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  .form-control {
    height: 38px;
    padding: 8px 12px;
    font-size: 1rem;
    font-weight: 400;
    line-height: 140%;
    color: var(--grey);
    border: 1px solid var(--grey);
    border-radius: 4px;

    &::placeholder {
      color: var(--input-color);
    }

    &:focus {
      box-shadow: none;
      border-color: var(--primary);
    }
  }
`

export const StatusMessage = styled.p<{ $tone: 'error' | 'success' }>`
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.4;
  color: ${({ $tone }) => ($tone === 'error' ? 'var(--red)' : 'var(--compose-cyan)')};
`

export const FooterActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
  flex-wrap: wrap;

  @media screen and (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: stretch;
  }
`

export const ConfirmButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 208px;
  height: 32px;
  padding: 8px 16px;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1rem;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: none;
  opacity: 1;
  background: var(--primary);
  color: var(--white);
  border: none;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background: var(--primary);
    color: var(--white);
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    height: auto;
    min-height: 40px;
    white-space: normal;
    text-align: center;
  }
`

export const CloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 32px;
  padding: 8px 16px;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1rem;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: none;
  opacity: 1;
  background: var(--white);
  color: var(--primary);
  border: 1.5px solid var(--primary);

  &:hover {
    background: var(--white);
    color: var(--primary);
    border-color: var(--primary);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    height: auto;
    min-height: 40px;
  }
`
